/*
 * *
 *   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *   ~  * No part of this publication may be reproduced, distributed,
 *   ~  * or transmitted in any form or by any means, including photocopying, recording,
 *   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *   ~  * except in the case of brief quotations embodied in critical
 *   ~  * reviews and certain other noncommercial uses permitted by copyright law.
 *   ~  * AUTHOR : bs
 *   ~  * DATE : 24/07/2025 15:52
 *
 */

export enum CartographyServiceResourceEventEnum {
  loadingGroup = 'loadingGroup',
  loadedGroup = 'loadedGroup',
  loadingResource = 'loadingResource',
  loadedResource = 'loadedResource',
  loadingModel = 'loadingModel',
  loadedModel = 'loadedModel',
  allLoaded = 'allLoaded',
  store = 'store',
}
